import { categories } from '@/mocks/categories';
import CategoryCard from '@/components/base/CategoryCard';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            探索内容分类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 font-body max-w-xl mx-auto">
            从剧情解析到角色介绍，从声优揭秘到名场面回顾，为你精心整理的内容分类
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <CategoryCard key={cat.slug} category={cat} />
          ))}
        </div>
      </div>
    </section>
  );
}